import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "3 pikchurs of a pretty goat",
  "description": "",
  "published": "2010-01-04T00:00:00.000Z",
  "redirect_from": ["/blog/3-pikchurs-of-a-pretty-goat/swizec/1050"],
  "categories": "funny, intrigues, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`While I was browsing through my blackberry a few moments ago to find a certain photo I stumbled upon some photos I took this Christmas.`}</p>
    <p>{`They're of a very bloody cute small boy goat thing. My grandmother says this is as big as they get and by god the little rascals are awesome. Soon as I came into the barn this guy jumped on me and demanded petting!`}</p>
    <p>{`PETTING!`}</p>
    <p>{`A goat!!`}</p>
    <p>{`:D`}</p>
    <p>{`Here he is, now let's make him famous just because he's so cool.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00104.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00104.jpg",
          "alt": "IMG00104",
          "title": "IMG00104"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00097.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00097.jpg",
          "alt": "IMG00097",
          "title": "IMG00097"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/01/IMG00090.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/01/IMG00090.jpg",
          "alt": "IMG00090",
          "title": "IMG00090"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      